import React, { useEffect, useState, useRef } from 'react';
import { Accordion, Badge, Card, Row, Col } from 'react-bootstrap'
import { toast } from 'react-toastify'; 
import { ReactComponent as Truck } from "../../../../assets/images/icon_svg/blue_truck.svg";
import { ReactComponent as BlueClock } from "../../../../assets/images/icon_svg/blue_clock.svg";
import { ReactComponent as Reset } from "../../../../assets/images/icon_svg/gray_updt.svg";
import { ReactComponent as Handeler } from "../../../../assets/images/icon_svg/handeler_icon.svg";
import { ReactComponent as TruckIconBg } from "../../../../assets/images/icon_svg/bg_truck_icon.svg";
import { ReactComponent as LocationMap } from "../../../../assets/images/icon_svg/map.svg";
import { ReactComponent as PaperPlane } from "../../../../assets/images/icon_svg/blue_paperpln.svg";
import { ReactComponent as LoadPoint } from "../../../../assets/images/icon_svg/loading_point.svg";
import { ReactComponent as UnloadPoint } from "../../../../assets/images/icon_svg/unloading_point.svg";
import { ReactComponent as RemainRoute } from "../../../../assets/images/icon_svg/remainning_route.svg";
import { ReactComponent as CompleteRoute } from "../../../../assets/images/icon_svg/complete_route.svg";
import Map from "../../../../assets/images/map.png";
import { CallApi } from '../../../../Components/common/CommonFunctions';

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M2.5 7L5.5 10L11.5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CaretIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M3 5L7 9L11 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const StepIcon = ({ status }) => {
  if (status === 'completed') {
    return <div className="step-icon completed"><CheckIcon /></div>;
  }
  if (status === 'active') {
    return (
      <div className="step-icon active">
        <svg width="10" height="10" viewBox="0 0 10 10">
          <circle cx="5" cy="5" r="4" fill="#3b82f6" />
          <circle cx="5" cy="5" r="2" fill="#fff" />
        </svg>
      </div>
    );
  }
  return (
    <div className="step-icon pending">
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
        <circle cx="5" cy="5" r="4" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    </div>
  );
};

const StatusBadge = ({ status }) => {
  if (status === 'completed') return <Badge className="badge-completed">Completed</Badge>;
  if (status === 'active') return <Badge className="badge-active">Active</Badge>;
  return <Badge className="badge-pending">Pending</Badge>;
};


const SourceIcon = ({ source }) => {
  if (source === 'trucker') return <TruckIconBg />;
  if (source === 'handler') return <Handeler />;
  if (source === 'airline') return <PaperPlane />;
  if (source === 'both') {
    return (
      <>
        <TruckIconBg />
        <Handeler className="ms-1" />
      </>
    );
  }
  return null;
};

const Tracking = () => {
  const [details, setDetails] = useState(null); 
  const [loading, setLoading] = useState(true);
  const isMounted = useRef(false);

  const fetchTrackingData = () => {
    let detID = null;
    try {
      const TODetails = JSON.parse(localStorage.getItem('TODetails'));
      detID = TODetails;
    } catch (e) {
      detID = null;
    }
    if (!detID) {
      setLoading(false);
      return;
    }
    console.log("inside tracking lets see ", detID)
    setLoading(true);
    CallApi({
      endPoint: `tracking-data?id=${detID}`,
      method: 'get',
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          setDetails(res.data.response_data?.timeline);
        } else {
          toast.error(res.data.response_msg);
        }
        setLoading(false);
      },
      onError: (msg) => {
        toast.error(msg);
        setLoading(false);
      }
    });
  };
  useEffect(() => {
    if (isMounted.current) return;
    fetchTrackingData();
    isMounted.current = true;
  }, []);

  const categories = details?.categories || [];

  return (
    <div className='summary_card rfs_tracking'>
      <div className="shipment-row">
        {/* ID + Date */}
        <div className="cell">
          <Truck />
          <span className="ship-id">{details?.trip_summary?.truck_no || '-'}</span>
          <span className="ship-date">· {details?.trip_summary?.truck_date || '-'}</span>
        </div>

        {/* Route */}
      <div className="cell">
          <div className="route">
            <span>{details?.trip_summary?.board_point || '-'}</span>
            <span className="arrow">→</span>
            <span>{details?.trip_summary?.off_point || '-'}</span>
          </div>
      </div>

        {/* Status */}
      <div className="cell">
          <div className="status-badge">
            <span className="status-dot" />
            {details?.trip_summary?.status || '-'}
          </div>
      </div>

        {/* ETA */}
      <div className="cell">
          <BlueClock />
          <span>ETA:</span>
          <span className="eta-value">{details?.trip_summary?.eta_formatted || '-'}</span>
          {!!details?.trip_summary?.delay_minutes && (
            <span className="delay-badge">
              ({details.trip_summary.delay_formatted || `+${details.trip_summary.delay_minutes} min`} delay)
            </span>
          )}
      </div>

        {/* Last Update */}
      <div className="cell">
          <Reset />
          <span className="last-update">Last update:</span>
          <span className="update-time">&nbsp;{details?.trip_summary?.last_update || '-'}</span>
        </div>
      </div>

      <div className='d-flex'>
        <div className='tw-20'>
          <Card className="border-0 rounded-0">
            <Card.Header className="">
              <Row className="align-items-center">
                <Col>
                  <h4 className="mb-0">Truck Status Timeline</h4>
                </Col>
                <Col xs="auto">
                  <div className="d-flex align-items-center">
                    <Reset className='me-2' />
                    <span className='updt_tym'>Updated {details?.updated_at || '-'}</span>
                  </div>
                </Col>
              </Row>
            </Card.Header>

            <Card.Body className="py-2">
              <div className="d-flex align-items-center flex-wrap gap-3">
                <span className="text-uppercase text-muted small fw-semibold">Source:</span>
                <div className="d-flex align-items-center gap-1">
                  <span className="source-icon"><TruckIconBg /></span>
                  <span>Trucker</span>
                </div>
                <div className="d-flex align-items-center gap-1">
                  <span className="source-icon"><Handeler /></span>
                  <span>Handler</span>
                </div>
                <div className="d-flex align-items-center gap-1">
                  <span className="source-icon"><TruckIconBg /></span>
                  <span className="source-icon"><Handeler /></span>
                  <span>Both</span>
                </div>
              </div>
            </Card.Body>
          </Card>

          <div className="tracking-wrapper">
            {loading ? (
              <div className="py-4 text-center text-muted">Loading timeline...</div>
            ) : categories.length === 0 ? (
              <div className="py-4 text-center text-muted">No tracking data available.</div>
            ) : (
              <Accordion
                defaultActiveKey={categories.find(s => s.status === 'active')?.name || categories[0]?.name}
                className="tracking-accordion"
              >
                {categories.map((step) => (
                  <Accordion.Item
                    key={step.name}
                    eventKey={step.name}
                    className={step.status === 'active' ? 'is-active' : ''}
                  >
                    <Accordion.Header>
                      <StepIcon status={step.status} />
                      <span className={`step-label ${step.status === 'pending' ? 'pending' : ''}`}>
                        {step.name}
                      </span>
                      <StatusBadge status={step.status} />
                      <span className="custom-caret"><CaretIcon /></span>
                    </Accordion.Header>

                    <div className="step-updated">
                      Updated {step.updated_at || '-'}
                    </div>

                    {!!(step.milestones && step.milestones.length) && (
                      <Accordion.Body>
                        {step.milestones.map((m, idx) => (
                          <div className="sub-item" key={idx}>
                            <div className="sub-icon">
                              {m.is_set ? <CheckIcon /> : <span className="dot-pending" />}
                            </div>
                            <div>
                              <div className="sub-label">
                                {m.display_label || m.label}
                                <SourceIcon source={m.source} />
                              </div>
                              {m.is_set && (
                                <div className="sub-meta">
                                  <span className="sub-meta-item">
                                    <SourceIcon source={m.source} />
                                    {m.value_formatted}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </Accordion.Body>
                    )}
                  </Accordion.Item>
                ))}
              </Accordion>
            )}
          </div>
        </div>

        <div className='tw-80'>
          <Card className="border-0 rounded-0 live_truck_loc">
            <Card.Header className="">
              <Row className="align-items-center">
                <Col>
                  <h4 className="mb-0">
                    Live Truck Location
                  </h4>

                </Col>

                <Col xs="auto">
                  <div className="d-flex align-items-center">
                    <Reset className='me-2' />
                    <span className='updt_tym'>12:15</span>
                    <span className="status-badge ms-2">
                      <span className="status-dot" />
                      In Transit
                    </span>
                  </div>
                </Col>
              </Row>
            </Card.Header>
          </Card>
          <div className='position-relative'>
            <img src={Map} alt='map' className='w-100' />
            <div className='route_info'>
              <h6 className='mb-2'>Route Info</h6>
              <p className='mb-2'><LocationMap /><span>From:</span> DXB Cargo Terminal</p>
              <p className='mb-2'><LocationMap /><span>To: </span>SHJ Freight Hub</p>
              <p className='mb-2'><PaperPlane /><span>Remaining:</span> 142 km</p>
              <p className='mb-2'><BlueClock /><span>ETA:</span> 16 Mar 14:30</p>
            </div>
            <div className='legend'>
              <h6 className='mb-2'>Legend</h6>
              <p className='mb-2'><CompleteRoute />Completed route</p>
              <p className='mb-2'><RemainRoute />Remaining route</p>
              <p className='mb-2'><LoadPoint />Loading point</p>
              <p className='mb-2'><UnloadPoint />Unloading point</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Tracking

// import { Accordion, Badge, Card, Row, Col, Ratio } from 'react-bootstrap'
// import { ReactComponent as Truck } from "../../../../assets/images/icon_svg/blue_truck.svg";
// import { ReactComponent as BlueClock } from "../../../../assets/images/icon_svg/blue_clock.svg";
// import { ReactComponent as Reset } from "../../../../assets/images/icon_svg/gray_updt.svg";
// import { ReactComponent as Handeler } from "../../../../assets/images/icon_svg/handeler_icon.svg";
// import { ReactComponent as TruckIconBg } from "../../../../assets/images/icon_svg/bg_truck_icon.svg";
// import { ReactComponent as LocationMap } from "../../../../assets/images/icon_svg/map.svg";
// import { ReactComponent as PaperPlane } from "../../../../assets/images/icon_svg/blue_paperpln.svg";
// import { ReactComponent as LoadPoint } from "../../../../assets/images/icon_svg/loading_point.svg"; 
// import { ReactComponent as UnloadPoint } from "../../../../assets/images/icon_svg/unloading_point.svg"; 
// import { ReactComponent as RemainRoute } from "../../../../assets/images/icon_svg/remainning_route.svg"; 
// import { ReactComponent as CompleteRoute } from "../../../../assets/images/icon_svg/complete_route.svg"; 
// import Map from "../../../../assets/images/map.png";
// const Tracking = () => {



//   return (
//     <div className='summary_card rfs_tracking'>
//       <div className="shipment-row">
//         {/* ID + Date */}
//         <div className="cell">
//           <Truck />
//           <span className="ship-id">EK4091T</span>
//           <span className="ship-date">· 16 Mar 2026</span>
//         </div>

//         {/* Route */}
//         <div className="cell">
//           <div className="route">
//             <span>FRA</span>
//             <span className="arrow">→</span>
//             <span>AMS</span>
//           </div>
//         </div>

//         {/* Status */}
//         <div className="cell">
//           <div className="status-badge">
//             <span className="status-dot" />
//             In Transit
//           </div>
//         </div>

//         {/* ETA */}
//         <div className="cell">
//           <BlueClock />
//           <span>ETA:</span>
//           <span className="eta-value">16 Mar 14:30</span>
//           <span className="delay-badge">(+15 min delay)</span>
//         </div>

//         {/* Last Update */}
//         <div className="cell">
//           <Reset />
//           <span className="last-update">Last update:</span>
//           <span className="update-time">&nbsp;12:15</span>
//         </div>
//       </div>
//       <div className='d-flex'>
//         <div className='tw-20'>
//           <Card className="border-0 rounded-0">
//             <Card.Header className="">
//               <Row className="align-items-center">
//                 <Col>
//                   <h4 className="mb-0">
//                     Truck Status Timeline
//                   </h4>
//                 </Col>

//                 <Col xs="auto">
//                   <div className="d-flex align-items-center">
//                     <Reset className='me-2' />
//                     <span className='updt_tym'>Updated 12:15</span>
//                   </div>
//                 </Col>
//               </Row>
//             </Card.Header>

//             <Card.Body className="py-2">
//               <div className="d-flex align-items-center flex-wrap gap-3">
//                 <span className="text-uppercase text-muted small fw-semibold">
//                   Source:
//                 </span>

//                 {/* Trucker */}
//                 <div className="d-flex align-items-center gap-1">
//                   <span className="source-icon">
//                     <TruckIconBg />
//                   </span>
//                   <span>Trucker</span>
//                 </div>

//                 {/* Handler */}
//                 <div className="d-flex align-items-center gap-1">
//                   <span className="source-icon">
//                     <Handeler />
//                   </span>
//                   <span>Handler</span>
//                 </div>

//                 {/* Both */}
//                 <div className="d-flex align-items-center gap-1">
//                   <span className="source-icon">
//                     <TruckIconBg />
//                   </span>

//                   <span className="source-icon">
//                     <Handeler />
//                   </span>

//                   <span>Both</span>
//                 </div>
//               </div>
//             </Card.Body>
//           </Card>

//           <div className="tracking-wrapper">
//             <Accordion defaultActiveKey="loading" className="tracking-accordion">

//               {/* ── Planning ── */}
//               <Accordion.Item eventKey="planning">
//                 <Accordion.Header>
//                   <div className="step-icon completed">
//                     <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
//                       <path d="M2.5 7L5.5 10L11.5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
//                         strokeLinejoin="round" />
//                     </svg>
//                   </div>
//                   <span className="step-label">Planning</span>
//                   <Badge className="badge-completed">Completed</Badge>
//                   <span className="custom-caret">
//                     <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
//                       <path d="M3 5L7 9L11 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
//                         strokeLinejoin="round" />
//                     </svg>
//                   </span>
//                 </Accordion.Header>
//                 <div className="step-updated">Updated 16/05/2026 12:00</div>
//               </Accordion.Item>

//               {/* ── Arriving Loading ── */}
//               <Accordion.Item eventKey="arriving">
//                 <Accordion.Header>
//                   <div className="step-icon completed">
//                     <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
//                       <path d="M2.5 7L5.5 10L11.5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
//                         strokeLinejoin="round" />
//                     </svg>
//                   </div>
//                   <span className="step-label">Arriving Loading</span>
//                   <Badge className="badge-completed">Completed</Badge>
//                   <span className="custom-caret">
//                     <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
//                       <path d="M3 5L7 9L11 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
//                         strokeLinejoin="round" />
//                     </svg>
//                   </span>
//                 </Accordion.Header>
//                 <div className="step-updated">Updated 16/05/2026 12:00</div>
//               </Accordion.Item>

//               {/* ── Loading (open by default) ── */}
//               <Accordion.Item eventKey="loading">
//                 <Accordion.Header>
//                   <div className="step-icon completed">
//                     <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
//                       <path d="M2.5 7L5.5 10L11.5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
//                         strokeLinejoin="round" />
//                     </svg>
//                   </div>
//                   <span className="step-label">Loading</span>
//                   <Badge className="badge-completed">Completed</Badge>
//                   <span className="custom-caret">
//                     <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
//                       <path d="M3 5L7 9L11 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
//                         strokeLinejoin="round" />
//                     </svg>
//                   </span>
//                 </Accordion.Header>
//                 <div className="step-updated">Updated 16/05/2026 12:00</div>
//                 <Accordion.Body>

//                   {/* Loading Started */}
//                   <div className="sub-item">
//                     <div className="sub-icon">
//                       <svg width="11" height="11" viewBox="0 0 14 14" fill="none">
//                         <path d="M2.5 7L5.5 10L11.5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
//                           strokeLinejoin="round" />
//                       </svg>
//                     </div>
//                     <div>
//                       <div className="sub-label">Loading Started <Handeler className='ms-2' /></div>
//                       <div className="sub-meta">
//                         <span className="sub-meta-item">
//                           <Handeler className='me-2' />
//                           16 Mar 09:42
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Loading Completed */}
//                   <div className="sub-item">
//                     <div className="sub-icon">
//                       <svg width="11" height="11" viewBox="0 0 14 14" fill="none">
//                         <path d="M2.5 7L5.5 10L11.5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
//                           strokeLinejoin="round" />
//                       </svg>
//                     </div>
//                     <div>
//                       <div className="sub-label">Loading Completed <TruckIconBg className='ms-2' /> <Handeler className='ms-2' /></div>
//                       <div className="sub-meta">
//                         <span className="sub-meta-item">
//                           <TruckIconBg />
//                           16 Mar 09:40
//                         </span>
//                         <span className="sub-meta-item">
//                           <Handeler />
//                           16 Mar 09:42
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Gate Out */}
//                   <div className="sub-item">
//                     <div className="sub-icon">
//                       <svg width="11" height="11" viewBox="0 0 14 14" fill="none">
//                         <path d="M2.5 7L5.5 10L11.5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
//                           strokeLinejoin="round" />
//                       </svg>
//                     </div>
//                     <div>
//                       <div className="sub-label">Gate Out <TruckIconBg className='ms-2' /></div>
//                       <div className="sub-meta">
//                         <span className="sub-meta-item">
//                           <TruckIconBg />
//                           16 Mar 09:58
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                 </Accordion.Body>
//               </Accordion.Item>

//               {/* ── At Unloading Station ── */}
//               <Accordion.Item eventKey="unloading-station" className="is-active">
//                 <Accordion.Header>
//                   <div className="step-icon active">
//                     <svg width="10" height="10" viewBox="0 0 10 10">
//                       <circle cx="5" cy="5" r="4" fill="#3b82f6" />
//                       <circle cx="5" cy="5" r="2" fill="#fff" />
//                     </svg>
//                   </div>
//                   <span className="step-label">At Unloading Station</span>
//                   <Badge className="badge-active">Active</Badge>
//                   <span className="custom-caret">
//                     <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
//                       <path d="M3 5L7 9L11 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
//                         strokeLinejoin="round" />
//                     </svg>
//                   </span>
//                 </Accordion.Header>
//                 <div className="step-updated">Updated 16/05/2026 12:00</div>
//               </Accordion.Item>

//               {/* ── Unloading ── */}
//               <Accordion.Item eventKey="unloading">
//                 <Accordion.Header>
//                   <div className="step-icon pending">
//                     <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
//                       <circle cx="5" cy="5" r="4" stroke="currentColor" strokeWidth="1.5" />
//                     </svg>
//                   </div>
//                   <span className="step-label pending">Unloading</span>
//                   <Badge className="badge-pending">Pending</Badge>
//                   <span className="custom-caret">
//                     <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
//                       <path d="M3 5L7 9L11 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
//                         strokeLinejoin="round" />
//                     </svg>
//                   </span>
//                 </Accordion.Header>
//                 <div className="step-updated">Updated -</div>
//               </Accordion.Item>

//             </Accordion>
//           </div>
//         </div>
//         <div className='tw-80'>
//           <Card className="border-0 rounded-0 live_truck_loc">
//             <Card.Header className="">
//               <Row className="align-items-center">
//                 <Col>
//                   <h4 className="mb-0">
//                     Live Truck Location
//                   </h4>

//                 </Col>

//                 <Col xs="auto">
//                   <div className="d-flex align-items-center">
//                     <Reset className='me-2' />
//                     <span className='updt_tym'>12:15</span>
//                     <span className="status-badge ms-2">
//                       <span className="status-dot" />
//                       In Transit
//                     </span>
//                   </div>
//                 </Col>
//               </Row>
//             </Card.Header>
//           </Card>
//           <div className='position-relative'>
//             <img src={Map} alt='map' className='w-100' />
//             <div className='route_info'>
//               <h6 className='mb-2'>Route Info</h6>
//               <p className='mb-2'><LocationMap /><span>From:</span> DXB Cargo Terminal</p>
//               <p className='mb-2'><LocationMap /><span>To: </span>SHJ Freight Hub</p>
//               <p className='mb-2'><PaperPlane /><span>Remaining:</span> 142 km</p>
//               <p className='mb-2'><BlueClock /><span>ETA:</span> 16 Mar 14:30</p>
//             </div>
//             <div className='legend'>
//               <h6 className='mb-2'>Legend</h6>
//               <p className='mb-2'><CompleteRoute />Completed route</p>
//               <p className='mb-2'><RemainRoute />Remaining route</p>
//               <p className='mb-2'><LoadPoint />Loading point</p>
//               <p className='mb-2'><UnloadPoint />Unloading point</p>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   )
// }

// export default Tracking